import { useQuery } from '@tanstack/react-query';
import type { Session } from '../../api/session';
import { getFeed } from '../../api/tenant';
import { Skeleton } from '../../ui/Skeleton';
import p from '../passes/passes.module.css';
import s from './more.module.css';

/** Activity log of passes, requests and powers of attorney (GET /v1/feed is not news). */
export function FeedScreen({ session }: { session: Session }) {
  const feed = useQuery({ queryKey: ['feed'], queryFn: () => getFeed(session) });
  return (
    <main className={p.page}>
      <h1 className={p.title}>Лента событий</h1>
      {!feed.data ? (
        <Skeleton height={160} />
      ) : feed.data.length === 0 ? (
        <p className={p.empty}>Событий пока нет</p>
      ) : (
        <ul className={p.list}>
          {feed.data.map((e, i) => (
            <li key={`${e.happenedAt}-${i}`} className={s.row}>
              <span className={s.rowText}>
                <span className={s.rowName}>{e.title}</span>
                {e.message && <span className={s.text}>{e.message}</span>}
                <span className={s.rowSub}>{e.happenedAt}</span>
              </span>
            </li>
          ))}
        </ul>
      )}
    </main>
  );
}
